<template>
    <div class="bax-main-wrapper">
        <header>
            <div class="container">
                <div class="d-flex">
                    <div class="bax-logo">
                        <h1>
                            <router-link :to="{name: 'home'}">
                                <img src="@/assets/images/logo.jpg" alt="Baxter Compounding">
                            </router-link>
                        </h1>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="bax-login-section">
                <div class="container">
                    <div class="bax-form-wrapper">
                        <div class="bax-section-title">
                            <h1 class="d-flex align-items-center"><img src="@/assets/images/login-img.png" alt="Login">Log in</h1>
                            <span></span>
                        </div>

                        <div v-if="$session.flash.get('reset_password') === true" class="password-reset">
                            Password successfully reset, please enter your new details.
                        </div>

                        <div>
                            <p class="login-error" v-if="loginError === true">
                                {{ errorMessage }}
                            </p>
                            <form novalidate @submit.prevent="authenticate" v-if="!maintenanceMode">
                                <ul>
                                    <li>
                                        <div class="bax-form-group" v-bind:class="{ 'bax-form-error' : $v.username.$error }">
                                            <label>Username</label>
                                            <input type="text" v-model="username" />
                                        </div>
                                    </li>
                                    <li v-if="passwordLogin">
                                        <div class="bax-form-group" v-bind:class="{ 'bax-form-error' : $v.password.$error }">
                                            <label>Password</label>
                                            <input :type="passwordType" v-model="password">
                                            <a href="#" @click.prevent="togglePasswordVisibility"><i class="icon-show"></i></a>
                                        </div>
                                    </li>
                                </ul>
                                <div class="bax-cta-block d-md-flex align-items-center">
                                    <button type="submit" class="bax-btn bax-btn-blue">
                                      <span v-if="passwordLogin">Login</span>
                                      <span v-else>Next</span>
                                    </button>
                                    <router-link
                                        :to="{name: 'forgotPassword'}"
                                        class="text-center text-md-right d-block d-md-inline-block ml-md-auto  mt-3 mt-md-0 "
                                        v-if="passwordLogin"
                                    >Forgot password</router-link>
                                </div>
                            </form>
                            <div v-else>
                                The Baxter Online Tool is currently being upgraded with new features. You can access BOLT again from 7:00 AM on 10/07/23
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
/* eslint-disable */
import { required } from 'vuelidate/lib/validators';
import Login from '@/core/api/auth/Login.class';

export default {
    name: 'Login',
    data() {
        return {
            passwordType: 'password',
            username: '',
            password: '',
            loginError: false,
            errorMessage: '',
            maintenanceMode: false,
            passwordLogin: true,
        };
    },
    validations: {
        username: {
            required,
        },
        password: {
            required,
        },
    },
    async mounted() {

        const hostname = location.hostname;
        // this.maintenanceMode = (hostname == 'compounding.baxterhealthcare.com.au') || (hostname == 'compounding.baxter.co.nz');
        this.maintenanceMode = false;

      if(this.$route.query.SAMLResponse) {

        const details = {
          'SAMLResponse': this.$route.query.SAMLResponse,
        };

        let formBody = [];
        for (var property in details) {
          const encodedKey = encodeURIComponent(property);
          const encodedValue = encodeURIComponent(details[property]);
          formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        fetch('https://baxter-admin.lndo.site/saml/acs', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: formBody
        }).then(
          response => {
            const data = response.json();
            console.log(response);
            console.log(data);
          });
      };


    },
    methods: {
        togglePasswordVisibility() {
            if (this.passwordType === 'password') {
                this.passwordType = 'text';
            } else {
                this.passwordType = 'password';
            }
        },
        async authenticate() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                //
            } else {
                const { username, password } = this;

                try {
                    const response = await Login.verifyUser(username, password);

                    localStorage.setItem('logout_token', response.data.logout_token);
                    localStorage.setItem('csrf_token', response.data.csrf_token);

                    await this.$store.dispatch('LOGIN_REQUEST', { username, password });

                    this.$router.push({ name: 'home' });
                } catch (err) {
                    this.loginError = true;
                    if (err.response.status === 400) {
                        this.errorMessage = 'Username or password are not valid, please try again';
                    } else if (err.response.status === 403) {
                        this.errorMessage = err.response.data.message;
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.bax-form-error {
    input {
        border: 1px solid red !important;
    }
}
.login-error {
    color: red;
    font-size: 15px;
}
.password-reset {
    font-size: 14px;
    color: #1E948D;
}
.bax-section-title {
    height: 88px;
}
</style>
